module.exports = __webpack_public_path__ + "images/121_320.jpg";